import React from "react";
import { CssBaseline, Box } from "@mui/material";
import Appbar from "./appbar.component";
import useWidth from "../hooks/useWidth";
import FooterComponent from "./footer.component";
// import HelpfulLinksScreen from "../screen/HelpfulLinksScreen";


function Main({ children }) {
    const url = window.location.pathname;
    const breakpoints = useWidth();

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: url === "/view/pdf" ? "#80808021" : {},
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    // maxWidth: url === "/" ? {} : static_variable.mainContainer_maxWidth,
                    overflowY: breakpoints === "xs" || breakpoints === "sm" ? {} : "hidden",
                    height: "100%",
                }}
            >
                {children}
            </Box>
        </Box>
    );
}

function MainLayout({ children }) {

    return (
        <>
            <CssBaseline />
            
            <Appbar />

            <Main>
                <Box>
                    {children}
                </Box>
            </Main>

            {/* <br/>
            <HelpfulLinksScreen />
            <br/> */}
            <FooterComponent /> 

        </>
    );
}

export default MainLayout;
